import Nav from "../../Components/Nav/Nav"
import Footer from "../../Components/Footer/Footer"
import ContactForm from "../../Components/ContactForm/ContactForm"


export default function ContactMe(){
    return(
        <div className="contactMe">  
            <div className="blur-light"></div>
            <Nav />
            <ContactForm />
            <Footer />
        </div>
    )
}